/**
 * This sort function will sort strings in alphanumeric order.
 *
 * @example
 * const arr = ['a1', 'a2', 'a10', 'a11', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9'];
 * arr.sort(sortAlphaNumeric);
 * // ['a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9', 'a10', 'a11']
 *
 * @param a string to compare
 * @param b string to compare
 * @returns number
 */
export function sortAlphaNumeric(a: string, b: string) {
  const reA = /[^a-zA-Z]/g;
  const reN = /[^0-9]/g;
  const aA = a.replace(reA, '').toLowerCase();
  const bA = b.replace(reA, '').toLowerCase();
  if (aA === bA) {
    const aN = parseInt(a.replace(reN, ''), 10);
    const bN = parseInt(b.replace(reN, ''), 10);
    return aN === bN ? 0 : aN > bN ? 1 : -1;
  } else {
    return aA > bA ? 1 : -1;
  }
}
